import * as Types from '../../../gql/types';

import {gql} from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type EditorAddCartItemMutationVariables = Types.Exact<{
  productId: Types.Scalars['ID']['input'];
  reference: Types.ReferenceInput;
  quantity?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type EditorAddCartItemMutation = {
  __typename?: 'Mutation';
  addCartItem?: {
    __typename?: 'AddCartItemPayload';
    me: {
      __typename?: 'User';
      id: string;
      cart: {
        __typename?: 'Cart';
        amount: number;
        count: number;
        items: Array<{
          __typename?: 'CartItem';
          id: string;
          quantity: number;
          product: {__typename?: 'InventoryItem'; id: string; price: number};
          reference?: {
            __typename?: 'Poster';
            name: string;
            id: string;
            image: {__typename?: 'Image'; url: any};
          } | null;
        }>;
      };
    };
    errors: Array<{__typename?: 'Error'; message: string}>;
  } | null;
};

export const EditorAddCartItemDocument = gql`
  mutation editorAddCartItem(
    $productId: ID!
    $reference: ReferenceInput!
    $quantity: Int
  ) {
    addCartItem(
      productId: $productId
      reference: $reference
      quantity: $quantity
    ) {
      me {
        id
        cart {
          amount
          count
          items {
            id
            quantity
            product {
              id
              price
            }
            reference {
              id
              ... on Poster {
                name
                image {
                  url
                }
              }
            }
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
export type EditorAddCartItemMutationFn = ApolloReactCommon.MutationFunction<
  EditorAddCartItemMutation,
  EditorAddCartItemMutationVariables
>;

/**
 * __useEditorAddCartItemMutation__
 *
 * To run a mutation, you first call `useEditorAddCartItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditorAddCartItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editorAddCartItemMutation, { data, loading, error }] = useEditorAddCartItemMutation({
 *   variables: {
 *      productId: // value for 'productId'
 *      reference: // value for 'reference'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useEditorAddCartItemMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EditorAddCartItemMutation,
    EditorAddCartItemMutationVariables
  >
) {
  const options = {...defaultOptions, ...baseOptions};
  return ApolloReactHooks.useMutation<
    EditorAddCartItemMutation,
    EditorAddCartItemMutationVariables
  >(EditorAddCartItemDocument, options);
}
export type EditorAddCartItemMutationHookResult = ReturnType<
  typeof useEditorAddCartItemMutation
>;
export type EditorAddCartItemMutationResult =
  ApolloReactCommon.MutationResult<EditorAddCartItemMutation>;
export type EditorAddCartItemMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    EditorAddCartItemMutation,
    EditorAddCartItemMutationVariables
  >;
